import { twMerge } from "tailwind-merge";
import { formatNaira } from "../../../utils/formatNaira";
import { IPrice } from "../../../store/@types/requests";

type IPriceCard = {
  priceItem: IPrice[];
  onStartEditPrice: (priceItem: IPrice) => void;
  onCancelEditPrice: () => void;
  handleUpdatePrice: (
    event: React.FormEvent<HTMLFormElement>,
    priceId: string,
  ) => void;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  editingPriceId: string | null;
  agreementNote: string;
  priceLoading: boolean;
};

export const PriceCard = ({
  priceItem,
  onStartEditPrice,
  onCancelEditPrice,
  handleUpdatePrice,
  onChange,
  editingPriceId,
  agreementNote,
  priceLoading,
}: IPriceCard) => {
  return (
    <div className="space-y-3 mt-1">
      {priceItem.length > 0 &&
        [...priceItem].reverse().map((price) => {
          return (
            <div
              key={price.id}
              className={twMerge(
                "rounded-lg border border-gray-100 p-3 bg-gray-50/20",
                price.is_agreed === 1 && price.status !== "failed"
                  ? "border-primary-300 bg-primary-50/30"
                  : "inert",
                price.status === "failed" ? "border-red-500 bg-red-50/30" : "",
                price.agreed_admin_confirm_date !== null &&
                  price.status !== "failed" &&
                  "border-primary-500 bg-primary-50/30",
              )}
            >
              <div className="flex items-center justify-between gap-2">
                <p className="text-sm font-semibold text-gray-700">
                  {formatNaira(price.price)}{" "}
                  {price.submitted_by === "admin"
                    ? "(Admin offer)"
                    : "(Counter offer)"}{" "}
                  {price.is_agreed === 1 &&
                    price.agreed_admin_confirm_date !== null &&
                    price.status !== "failed" &&
                    "🤝"}
                </p>
                <div className="flex items-center gap-2">
                  <div className="flex items-center gap-3">
                    <button
                      type="button"
                      onClick={() => onStartEditPrice(price)}
                      disabled={priceLoading}
                      className={twMerge(
                        "text-xs text-blue-600 hover:text-blue-700 underline underline-offset-2",
                        // price.is_agreed === 1 ? "" : "hidden",
                      )}
                    >
                      Update note
                    </button>
                    {price.is_agreed === 1 && price.payment_link && (
                      <button
                        type="button"
                        onClick={() =>
                          window.open(price.payment_link ?? "", "_blank")
                        }
                        disabled={priceLoading}
                        className="text-xs text-primary-600 hover:text-primary-700 underline underline-offset-2"
                      >
                        Pay now
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-500 mt-1">
                Agreement note:{" "}
                {price.agreement_note?.trim() || "No note added."}
              </p>
              {editingPriceId === price.id.toString() && (
                <form
                  onSubmit={(event) =>
                    handleUpdatePrice(event, price.id.toString())
                  }
                  className="mt-3 space-y-2"
                >
                  <textarea
                    value={agreementNote}
                    onChange={onChange}
                    rows={3}
                    placeholder="Update agreement note"
                    className="w-full rounded-md border border-gray-200 px-3 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-primary-200"
                  />
                  <div className="flex items-center gap-2">
                    <button
                      type="submit"
                      disabled={priceLoading}
                      className="px-2.5 py-1 text-xs rounded-md bg-primary-600 text-white hover:bg-primary-700 transition-colors"
                    >
                      {priceLoading ? "Saving..." : "Save note"}
                    </button>
                    <button
                      type="button"
                      onClick={onCancelEditPrice}
                      disabled={priceLoading}
                      className="px-2.5 py-1 text-xs rounded-md border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              )}
            </div>
          );
        })}
    </div>
  );
};
